import { render, staticRenderFns } from "./EcommerceInfo.vue?vue&type=template&id=0d6217c1"
import script from "./EcommerceInfo.vue?vue&type=script&lang=ts"
export * from "./EcommerceInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports